import React from "react"
import "./index.css"

const DashboardCard = props => (
    <div className={`dashboard-card${props.className ? " " + props.className : ""}`}>
        {props.children}
    </div>
)

export default DashboardCard


// WEBPACK FOOTER //
// ./src/components/dashboard-card/DashboardCard.js